import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid } from '@mui/material';
import { BtnBack, BtnCancel, BtnSave } from 'components/Button/ButtonAll';
import { FormProvider, useForm } from 'react-hook-form';
import { TextAreaItem } from 'components/Input/TextArea';
import { EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { I18n, } from 'utilities/utilities';

const ModalProjectCancel = ({ isOpenCancel, setisOpenCancel, handleSubmit }) => {

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            sRemarkCancel: null,
        },
    });

    return (
        <DialogPreview
            IsOpen={isOpenCancel}
            Title={"ยกเลิกคำขอ"}
            sMaxWidth="sm"
            JsxDialogAction
            CloseSave={false}
            Close={false}
            onCustomButton={
                <Grid
                    container
                    spacing={2}
                    justifyContent={"center"}
                >
                    <Grid item>
                        <BtnCancel 
                            id={"BtnBackCancel"} 
                            onClick={() => setisOpenCancel(false)} 
                        />
                    </Grid>
                    <Grid item>
                        <BtnSave 
                            id={"BtnSaveCancel"} 
                            txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)} 
                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Cancel, EnumProjectStatusID.nStatusID_31, I18n.SetText("Button.CancelReques", I18NextNs.labelComponent), form.getValues("sRemarkCancel")),(err) => console.log("err", err))}
                        />
                    </Grid>
                </Grid>
            }
        >
            <Grid container spacing={1} justifyContent={"center"} alignItems={"start"}>
                <FormProvider {...form}>
                    <Grid item xs={12}>
                        <TextAreaItem
                            id={"sRemarkCancel"}
                            name={"sRemarkCancel"}
                            label={"หมายเหตุ/เหตุผล"} 
                            IsDisplayLabel={true}                              
                            required={true}
                            maxLength={500}
                            row={3}
                            disabled={false}
                        />
                    </Grid>
                </FormProvider>
            </Grid>
        </DialogPreview>
    )
}

export default ModalProjectCancel
